import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getdataByIdInv_Mis = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_MISCELLANEOUS}` + `/getbyid/${id}`);
};

export const billing_expense_printInvMIS = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.INVOICE_MISCELLANEOUS}` + `/print_inv_mis/${id}`);
};

export const billing_expense_addInv_Mis = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.INVOICE_MISCELLANEOUS}` + `/`, data);
};

export const billing_expense_deleteInv_Mis = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.INVOICE_MISCELLANEOUS}` + `/${id}`);
};
